/* EdgePro site gallery: prev/next arrows for the photo rail. The native
   scrollbar stays hidden in CSS; arrows page the rail by one item and
   disable at the ends. Touch swipe and keyboard scrolling untouched. */
(function () {
  if (window.__epSgNav) return;
  window.__epSgNav = true;

  function init(section) {
    var rail = section.querySelector('.ep-sg__rail');
    var nav = section.querySelector('[data-ep-sg-nav]');
    if (!rail || !nav) return;
    var prev = nav.querySelector('[data-ep-sg-prev]');
    var next = nav.querySelector('[data-ep-sg-next]');

    function step() {
      var item = rail.querySelector('.ep-sg__item');
      if (!item) return rail.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (max <= 4) {
        nav.hidden = true;
        return;
      }
      nav.hidden = false;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= max - 4;
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  document.querySelectorAll('.ep-sg').forEach(init);
})();
